import PropTypes from "prop-types";
import React, { Component } from "react";
import {
    Container
} from "../../../../../../components/index";


// class definition
export class SelectedIcon extends Component {

    static propTypes = {
        style: PropTypes.any,
        selected: PropTypes.bool
    };

    static defaultProps = {
        style: {},
    };

    render() {

        // resolve input
        const { style, selected } = this.props;


        // create container style
        let containerStyle = {...styles.container, ...styles.containerSize, ...style};

        if (selected) {
            containerStyle = {...containerStyle, ...styles.containerSelected};
        }

        // create conditional vertical mark if selected
        const markSelected = selected
            ? <Container />
            : <Container style={styles.markSelected} />;

        // render view
        return (
            <Container flex touchless style={containerStyle}
                justify="center"
                alignItems="center" >
                <Container style={styles.markUnselected} />
                {markSelected}
            </Container >
        );
    }
}


const styles = {
    container: {
        backgroundColor: "#2b2b2b",
        borderRadius: 13,
    },
    containerSize: {
        width: 26,
        height: 26,
    },
    containerSelected: {
        backgroundColor: "#5b5b5b"
    },
    markUnselected: {
        width: 10,
        height: 1,
        backgroundColor: "#e53c2e"
    },
    markSelected: {
        position: "absolute",
        width: 1,
        height: 10,
        backgroundColor: "#e53c2e"
    }
};



// WEBPACK FOOTER //
// ./src/pages/Customization/components/Customize/components/Inventory/SelectedIcon.js